module.exports = __webpack_public_path__ + "img/maintop.d3dcdda.png";